import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./screen.css";
import "./styles.css";
import Loader from "./Loader";
import Sidebar from "./SideBar";
const LOGIN_API_URL = process.env.REACT_APP_LOGIN_API_URL;
export default function AllUser() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setloading] = useState(true);

  const [allUsers, setAllUsers] = useState([]);
  const [currentRole, setCurrentRole] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); // 🔍 NEW
  useEffect(() => {
    if (!location?.state?.role) {
      navigate("/dashboard");
    }
    // eslint-disable-next-line
  }, [location]);
  const getusers = async () => {
    const role = location?.state?.role;
    setCurrentRole(role);

    fetch(`${LOGIN_API_URL}/login.php?getallusers=true`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response?.status} ${response?.statusText}`
          );
        }
        return response.json();
      })
      .then((result) => {
       // console.log(result, "######### data from api #########");
        if (result.status === "No room added") {
          setAllUsers([]);
        } else {
          // setAllUsers(result)
          let filtered = result;

          //   const userId = await AsyncStorage.getItem("loginId"); // for user self-check

          switch (role) {
            case "Product Managers":
              // Show all
              filtered = result.filter(
                (user) => user.role === "Product Manager"
              );
              break;

            case "Site Managers":
              // Hide ProductManagers
              //  filtered = result.filter((user) => user.role == "Product Manager");
              filtered = result.filter((user) => user.role === "Site Manager");

              break;

            case "Technicians":
              // Show only users with role "user"
              //  filtered = result.filter((user) => user.role === "User");
              filtered = result.filter((user) => user.role === "Technician");
              break;

            case "Users":
              // Show only current user
              //  filtered = result.filter((user) => user.loginId === userId);
              filtered = result.filter((user) => user.role === "User");
              break;

            default:
              break;
          }

          setAllUsers(filtered);
          setloading(false);
        }
      })
      .catch((error) => {
        console.log(error, "Error");
      });
  };

  useEffect(() => {
    getusers();
    // eslint-disable-next-line
  }, [location]);

  const deleteuser = async (id) => {
    fetch(`${LOGIN_API_URL}/login.php?deletecid=${id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response?.status} ${response?.statusText}`
          );
        }
        return response.json();
      })
      .then((result) => {
     //   console.log(result, "######### data from api #########");
        getusers();
      })
      .catch((error) => {
        console.log(error, "Error");
      });
  };

  const filteredUsers = allUsers.filter((user) =>
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ display: "flex", height: "100vh", width: "100%" }}>
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div
        style={{
          flex: 1,
          padding: "30px",
          backgroundColor: "#fff",
          overflowY: "auto",
        }}
      >
        <h1 style={{ marginBottom: 30, fontSize: "30px" }}>
          {location?.state?.role === "Users"
            ? "Users"
            : location?.state?.role === "Technicians"
            ? "Technicians"
            : location?.state?.role === "Site Managers"
            ? "Site Managers"
            : "Product Managers"}
        </h1>
        <input
          type="text"
          placeholder="Search by email..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "10px",
            marginBottom: "30px",
            width: "100%",
            maxWidth: "400px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "100%",
          }}
        />
        {/* Cards Grid */}
        {loading ? (
          <div
            style={{
              width: "80vw",
              height: "70vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader message="Please Wait..." />
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  backgroundColor: "#fff",
                  borderRadius: 12,

                  // overflow: "hidden",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "#489ff6",
                    color: "#fff",
                    zIndex: 2,
                  }}
                >
                  <tr
                    style={{
                      backgroundColor: "#489ff6",
                      color: "#fff",
                      cursor: "pointer",
                      textAlign: "left",
                    }}
                  >
                    <th style={{ padding: "12px 16px" }}>Name</th>
                    <th style={{ padding: "12px 16px" }}>Email</th>
                    <th style={{ padding: "12px 16px" }}>Phone</th>
                    <th style={{ padding: "12px 16px" }}>Type</th>
                    <th style={{ padding: "12px 16px" }}>Organization</th>
                    {localStorage.getItem("role") !== "User" &&
                    localStorage.getItem("role") !==
                      location?.state?.role?.slice(0, -1) ? (
                      <th style={{ padding: "12px 16px" }}>Edit</th>
                    ) : null}
                    {localStorage.getItem("role") !== "User" &&
                    localStorage.getItem("role") !== "Technician" &&
                    localStorage.getItem("role") !==
                      location?.state?.role?.slice(0, -1) ? (
                      <th style={{ padding: "12px 16px" }}>Delete</th>
                    ) : null}
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers?.map((card) => (
                    <tr
                      key={card.loginId} // Use stable unique key
                      style={{
                        borderBottom: "1px solid #eee",
                        cursor:
                          currentRole === "User" || currentRole === "Technician"
                            ? "pointer"
                            : "pointer",
                      }}
                      onClick={() => {
                        navigate("/mac", {
                          state: {
                            role: "Devices",
                            userId: card.loginId,
                          },
                        });
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#dde8ed";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }}
                    >
                      <td style={{ padding: "12px 16px" }}>
                        {card.username || "N/A"}
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        {card.email || "N/A"}
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        {card.phone || "N/A"}
                      </td>
                      <td style={{ padding: "12px 16px" }}>{card.role}</td>
                      <td style={{ padding: "12px 16px" }}>
                        {card.organization || "N/A"}
                      </td>

                      {/* Edit Button: Show only if current user is not a User and not editing same role */}
                      {localStorage.getItem("role") !== "User" &&
                      localStorage.getItem("role") !== card.role ? (
                        <td
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent triggering row click
                            if (currentRole !== "User") {
                              navigate("/edituser", { state: { card } });
                            }
                          }}
                          style={{ padding: "12px 16px", cursor: "pointer" }}
                        >
                          <img
                            src={require("../img/edit.png")}
                            style={{ width: 22, height: 22 }}
                            alt="edit"
                          />
                        </td>
                      ) : null}

                      {/* Delete Button: Only Admins (not User/Technician) can delete */}
                      {localStorage.getItem("role") !== "User" &&
                      localStorage.getItem("role") !== "Technician" &&
                      localStorage.getItem("role") !== card.role ? (
                        <td
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent triggering row click
                            if (
                              window.confirm(
                                "Are you sure you want to delete this user?"
                              )
                            ) {
                              deleteuser(card.loginId);
                            }
                          }}
                          style={{ padding: "12px 16px", cursor: "pointer" }}
                        >
                          <img
                            src={require("../img/delete.png")}
                            style={{ width: 23, height: 23 }}
                            alt="delete"
                          />
                        </td>
                      ) : null}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
